<template>
    <div class="main">
        <report-top>
            <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
        <selectTool ref="selectTool">
            <template slot="btn"><Button @click="getSearchItem" type="primary" class="chaxun">查询</Button><Button
                    @click="exportAll" type="error" class="chaxun">导出</Button></template>
        </selectTool>

        <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
            :height="utils.setTableHeight(200)">

        </Table>
        <div id="mypage">
            <div>
                <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]"
                    show-total show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange">
                </Page>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            isAdd: false,
            columns: [
                {
                    type: "index",
                    width: 70,
                    align: "center",
                },
                {
                    title: "日期",
                    key: "date2",
                },
                {
                    title: "车牌号",
                    key: "carNo",
                },
                {
                    title: "所属单位",
                    key: "groupName",
                },
                {
                    title: "趟次名称",
                    key: "ruleName",
                },
                {
                    title: "总时长/分",
                    key: "duration",
                },
                {
                    title: "总里程/km",
                    key: "mileage",
                }, {
                    title: "总费用",
                    key: "cost",
                }, {
                    title: "总趟数",
                    key: "total",
                },
                {
                    title: "正向趟数",
                    key: "fwdNum",
                },
                {
                    title: "反向趟数",
                    key: "bwdNum",
                },
                {
                    title: "正常趟数",
                    key: "normalNum",
                },
                {
                    title: "异常趟数",
                    key: "abnormalNum",
                },

            ],
            tableData: [],
            searchItem: {
                keyword: "",
                pageNumber: 1,
                pageSize: 50,
                deviceIdList: [],
                startTime: 0,
                endTime: 0
            },
            searchForms: [
                {
                    title: "车牌号",
                    key: "deviceIdList",
                    type: "selectAlotCar",

                },
                {
                    title: "时间范围",
                    key: "startTime",
                    key1: "endTime",
                    type: "lyyymmdd",
                    times: "2,0,1",
                },
            ],
            total: 0,
        };
    },
    methods: {
        getList() {
            this.tableData = [];
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-car-server-trp/times/sum",
                data: this.searchItem,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;
                for (let i = 0; i < data.length; i++) {
                    data[i].date2 = this.utils.time(data[i].date, 'yymmdd');
                }
                this.tableData = data;
            });
        },


        changePage(x) {
            this.searchItem.pageNumber = x;
            this.getList();
        },
        //每页总条数切换
        pageSizeChange(x) {
            this.searchItem.pageSize = x;
            this.getList();
        },
        search() {
            this.getList();
        },
        getSearchItem() {
            this.searchItem = this.$refs.selectTool.getItem();
            console.log(this.searchItem);
            this.getList();
        },
        exportAll() {
            var params = [
                {
                    name: "deviceIdList",
                    value: this.searchItem.deviceIdList,
                },
                {
                    name: "startTime",
                    value: this.searchItem.startTime,
                },
                {
                    name: "endTime",
                    value: this.searchItem.endTime,
                },
            ];
            this.utils.exportData(this.axios.ipPort + "/cloud-car-server-trp/times/export/sum", params);
        },

    },
    mounted() {
        var config = {
            min: 100,
            max: 300,
        };
        this.columns = this.utils.cols([], this.columns, config);
        this.$refs.selectTool.reach(this.searchForms, this.searchItem);
        setTimeout(() => {
            this.getSearchItem();
        }, 200);
    },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/tangci/tangcihuizong.vue